<template>

    <div class="price">

        <div class="price-updated"><span class="price-updated-number">{{ updatedPrice | toNumber }}</span> <span
                class="price-updated-unit">{{ unit }}</span></div>

        <transition name="fade" :duration="{ enter: 500, leave: 800 }">
            <div class="savings-wrapper" v-show="showSavings && savings > 0">
                <div class="savings-text" v-if="feeType!='once'">Savings per year: <span>{{ savings | toCurrency }}</span> </div>
                <div class="savings-text" v-if="feeType=='once'">Savings: <span>{{ savings | toCurrency }}</span> </div>
                <div class="original-price">Orig price: <span>{{ originalPrice | toCurrency }}</span></div>
            </div>
        </transition>

        <div v-if="debug">
        Original Price: {{ originalPrice }}<br/>
        Updated Price: {{ updatedPrice }}<br/>
        Savings: {{ savings }}<br/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    originalPrice: {
      type: Number,
      default: 0
    },
    updatedPrice: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    feeType: {
      type: String,
      default: 'monthly'
    },
    showSavings: {
      default: true
    }
  },
  data: function () {
    return {
      savings: 0,
      debug: false
    }
  },
  watch: {
    updatedPrice: function () {
      this.calculateSavings()
    },
    originalPrice: function () {
      this.calculateSavings()
    }
  },
  mounted () {
    if (this.showSavings) {
      this.calculateSavings()
    }
  },
  methods: {
    calculateSavings () {
      if (this.feeType === 'monthly') {
        this.savings = (this.originalPrice - this.updatedPrice) * 12
      } else if (this.feeType === 'once') {
        this.savings = (this.originalPrice - this.updatedPrice)
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../styles/variables';
    @import '../../node_modules/vuetify/dist/vuetify.min.css';

    .fade-enter-active, .fade-leave-active {
        transition: all 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .price {
        &.annual-total .price-updated,
        &.quarterly-total .price-updated {
            &:after {
                content: '=';
                color: $growth;
                display: inline-block;
                vertical-align: top;
                font-size: 30px;
                padding-left: 35px;
                margin-top: 10px;
            }
        }
    }

    .price-label {
        text-transform: uppercase;
        font-family: $head-semi-bold-font-family;
        color: $text-15;
        letter-spacing: -0.03em;
        font-size: 12px;
        margin-bottom: 0;
    }

    .price-updated {
        display: inline-block;
        letter-spacing: -0.03em;
        .price-updated-number {
            font-family: $body-font-family;
            font-size: 4.5em;
            line-height: 66px;
            color: $growth;
            display: inline-block;
            position: relative;
            &:before {
                content: '$';
                font-size: 0.5em;
                vertical-align: top;
                line-height: 10px;
            }
            &.extra-savings:after {
                content: 'Extra savings!';
                color: #fff;
                padding: 0.5em 0.6em 0.6em 1em;
                font-size: 16px;
                line-height: 16px;
                vertical-align: top;
                top: -10px;
                position: absolute;
                white-space: nowrap;
            }

            .order-summary & {
                font-size: 3em;
                line-height: normal;
                &:before {
                    font-size: 0.3em;
                    line-height: 55px;
                }
            }

        }
        .price-updated-unit {
            font-family: $body-font-family;
            font-size: 1.25em;
            color: $growth;
            display: inline-block;
            margin-bottom: 10px;

            .order-summary & {
                margin-bottom: 0;
            }

        }
    }
    .savings-wrapper {
        .order-summary & {
            display: none;
            .original-price {
                display: none;
            }
        }
    }

    .savings {
        display: inline-block;
        padding: .5em 1em;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        color: #fff;
        background-color: $growth;
        margin-bottom: 40px;
        span {
            color: #fff;
        }
    }

    .savings-text {
        display: inline-block;
        color: $growth;
        font-family: $head-semi-bold-font-family;
        font-size: 1.25em;
        margin-right: 15px;
        letter-spacing: -0.03em;
        span {
            font-family: $head-semi-bold-font-family;
            font-size: 1.5em;
            color: $growth;
        }

        .order-summary & {
            font-size: 0.75em;
            display: block;
            span {
                font-size: 1.5em;
            }
        }
    }

    .original-price {
        display: inline-block;
        font-family: $head-semi-bold-font-family;
        color: $core;
        font-size: 1.25em;

        span {
            text-decoration: line-through;
            color: $core;
            font-size: 1.5em;
        }

        .order-summary & {
            font-size: 0.75em;
            display: block;
            span {
                font-size: 1.125em;
            }
        }

    }

    @media (min-width: 992px) {

        .price {
            min-height: 130px;
        }
        .order-summary .price {
            min-height: unset;
        }

        .price-updated {
            .price-updated-number {
                font-size: 4.5em;
                line-height: 66px;
                &:before {
                    font-size: 0.5em;
                    line-height: 1.7em;
                }
            }
            .price-updated-unit {
                font-size: 1em;
                margin-bottom: 20px;
            }
        }

        .savings-text {
            font-size: 1em;
            margin-right: 15px;
            span {
                font-size: 1.625em;
            }
        }

        .original-price {
            font-size: 1em;
            span {
                font-size: 1.625em;
            }
        }

    }

    @media (min-width: 1200px) {

        .price {
            min-height: 190px;
            &.annual-total .price-updated {
                &:after {
                    font-size: 40px;
                    padding-left: 60px;
                    margin-top: 10px;
                }
            }
        }

        .price-updated {
            .price-updated-number {
                font-size: 8em;
                line-height: 66px;
                &:before {
                    font-size: 0.5em;
                    line-height: 10px;
                }
                .order-summary & {
                    font-size: 3.75em;
                    line-height: normal;
                    &:before {
                        font-size: 0.3em;
                        line-height: 55px;
                    }
                }
            }
            .price-updated-unit {
                font-size: 1.25em;
                margin-bottom: 30px;
            }
            &:after {
                font-size: 30px;
                padding-left: 50px;
                margin-top: 20px;
            }
        }

        .savings-text {
            font-size: 1.25em;
            margin-right: 15px;
            span {
                font-size: 1.5em;
            }
            .order-summary & {
                font-size: 1em;
                display: block;
                span {
                    font-size: 1.5em;
                }
            }
        }

        .original-price {
            font-size: 1.25em;
            span {
                font-size: 1.5em;
            }
        }
    }

    @media (min-width: 1920px) {

        .price {
            .order-summary & {
                margin-top: 10px;
            }
            &.annual-total .price-updated {
                &:after {
                    font-size: 50px;
                    padding-left: 120px;
                    margin-top: 20px;
                }
            }
        }

        .price-updated {
            .price-updated-number {
                font-size: 9.25em;
                line-height: 66px;
                &:before {
                    font-size: 0.245em;
                    line-height: 10px;
                }

                .order-summary & {
                    font-size: 6em;
                    margin-bottom: 20px;
                }
            }
            .price-updated-unit {
                font-size: 1.25em;
                margin-bottom: 30px;
            }
            &:after {
                font-size: 50px;
                padding-left: 80px;
            }
        }

        .savings-text {
            font-size: 1.5em;
            margin-right: 15px;
            span {
                font-size: 1.25em;
            }
            .order-summary & {
                font-size: 1em;
                display: block;
                span {
                    font-size: 1.5em;
                }
            }
        }

        .original-price {
            font-size: 1.25em;
            span {
                font-size: 1.5em;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Price.vue